<template>
    <div class="FormBill">
        <v-easy-dialog v-model="simpleDialog">
            <div class="flex flex-col v-card textSend">
            <div>
                <p class = "titleModal">
                    <strong>Confirmamos la recepción de la solicitud, A continuación los pasos del proceso de gestión:</strong>
                </p>
            </div>
            <hr/>
            <div class = "infoModal">
                <p>
                    Te haremos llegar la copia de tu recibo de pago correspondiente a tu correo electrónico institucional en el transcurso de las próximas 72 horas hábiles.
                </p>
            </div>

            <div class="flex justify-end space-x-2">
                <button id="btnClose" @click="simpleDialog = false" style="float: right;">Cerrar</button>
            </div>
            </div>
        </v-easy-dialog>
        <div v-if="FormBill">
            <div class="container container-form">
                <div class="row">
                    <div class="col-md-6 infoForm">
                        <FormDataInscription /> 
                    </div>
                    <div class="col-md-6 totalform motBusUser">  
                        <div v-if="infoData" class="alert alert-danger">
                            <p>
                                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoCorrect" class="alert alert-success">
                            <p>
                                Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso y será atendido lo más pronto posible.
                            </p>
                        </div>
                        <h1 class="titleForm"><strong>Necesitas pagar y no tienes mucho tiempo.</strong></h1>
                        <p class="descriptionForm">
                            En la IBERO estamos evolucionando para tí.
                        </p>
                        <p class="descriptionForm">
                            Estamos intentando algo nuevo.
                        </p>
                        <p class="descriptionForm">
                            Para agilizar tus trámites, puedes llenar el formulario a continuación para recibir una copia de tu orden de matrícula en tu correo electrónico. Tendrás respuesta de tu solicitud dentro de 3 días hábiles a partir de el diligenciamiento del formulario. Utilizaremos el resto de tu información para actualizar tus datos y asegurarnos de poder estar siempre en contacto.
                        </p>
                        <ValidationObserver ref="obsformBill">
                            <FormBill :FieldsForm="formBill" :ModelForm="formInsModel" :method="executeProcess" />                                     
                        </ValidationObserver>
                        <div class="botoPnrocess">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="onComplete"
                                            class="loginbtn">
                                            Enviar
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataInscription from '@/views/InfoZone/FormBill.vue'
    import FormBill from '@/components/Forms.vue'
    import IberoHelpers from '@/store/helpers.js'
    import VEasyDialog from 'v-easy-dialog'

    export default{
        name: "FormBills",
        components: {
            FormDataInscription,
            FormBill,
            VEasyDialog,
        },
        methods:{
            dataObjCheck: function(InfDaT){
                if(InfDaT === true){
                    return this.$ml.get('Accepted');   
                }
                return this.$ml.get('NotAccepted');    
            },
            dataformat: function(InfDaT){
                return IberoHelpers.dataObjDate(InfDaT);
            },
            dataObjFindJs: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjFind(infoDaT,FinDaT);
            },
            dataObjAllFind: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
            },
            executeProcess: function (event){
                switch (event.target.id) {
                    case 'IdFile':
                        this.formUserFileModel = []   
                        event.target.nextElementSibling.innerText = event.target.files[0].name
                        this.formInsModel.IdFile = event.target.files[0].name
                        this.formUserFileModel.push({ filedata: event.target.files[0] })
                    break;
                }
            },
            clearForm: function(){
                this.infoData = false;
                this.formInsModel.IdName = '';
                this.formInsModel.IdLastname = '';
                this.formInsModel.Mobile = '';
                this.formInsModel.Email = '';
                this.formInsModel.Document = '';
                this.formInsModel.IdBanner = '';
                this.formInsModel.IdRequest = '';
                this.formInsModel.Message = '';
                this.formInsModel.IdFile = null;

                this.formBill[8].value = null;
                
                this.formBill[0].validate = false;
                this.formBill[1].validate = false;
                this.formBill[2].validate = false;
                this.formBill[3].validate = false;
                this.formBill[4].validate = false;
                this.formBill[5].validate = false;
                this.formBill[6].validate = false;
                this.formBill[7].validate = false;
            },
            onComplete: function() {
                return new Promise((resolve, reject) => {
                    this.$refs.obsformBill.validate().then(results => {
                        if(!results){
                            IberoHelpers.scrollToTop(0,300);
                            resolve(false)
                        }
                        else{
                            let loader = this.$loading.show();
                            var createCase = IberoHelpers.sendCaseZoho(this.$store,this.formInsModel);
                            createCase.then(Response => {
                                let numCase  = Response.data.title;
                                this.sendCase = numCase;
                                if (Response.data.title != ""){
                                    if (this.formUserFileModel.length > 0){
                                        var dataFile = IberoHelpers.sendUpdloadFile(this.$store, this.formUserFileModel, 'ADJUNTOWEB', 0)
                                        dataFile.then(Response => {
                                            if (!(Response === false)){
                                                for (var i=0; i < Response.length; i++) {
                                                    let valueRef = Response[i].wsDocument.data.id_File
                                                    let URIFile = Response[i].wsDocument.data.filePath
                                                    let refeFile = []  
                                                    refeFile.push({valueRef, URIFile: URIFile})
                                                    var FileZoho = {
                                                        IdCase: numCase,
                                                        FileDetail: refeFile,
                                                    }
                                                    var resulEnd = IberoHelpers.sendFileCases(this.$store, FileZoho, numCase);
                                                    resulEnd.then(Response => {
                                                        if (!(Response === false)) {
                                                            if (Response.data.status === '200') {                                
                                                                loader.hide();
                                                                IberoHelpers.scrollToTop(0,500);
                                                                this.infoData = false;
                                                                this.FormBill = false;
                                                                this.simpleDialog = true;
                                                                this.clearForm();
                                                                this.FormBill = true;
                                                                resolve(true)
                                                            } else {
                                                                loader.hide();
                                                                this.infoData = true;
                                                                resolve(false);
                                                            }
                                                        }
                                                        else 
                                                        {
                                                            loader.hide();
                                                            this.infoData = true;
                                                            resolve(false);
                                                        }                               
                                                    })   
                                                }
                                            }
                                        })
                                    }
                                    else{
                                        IberoHelpers.scrollToTop(0,100);
                                        resolve(true);
                                        loader.hide();
                                        this.infoData = false;
                                        this.FormBill = false;
                                        this.simpleDialog = true;
                                        this.FormBill = true;
                                        this.clearForm();
                                        data();
                                    }
                                }else{
                                    loader.hide();
                                    this.alertdanger = true;
                                    resolve(false);
                                }
                            });
                        }
                    });
                });
            },
        },
        data(){
            return {
                FormBill: true,
                infoData: false,
                infoCorrect: false,
                dangerData: false,
                simpleDialog: false,
                sumaryData: [],
                sendCase: [],
                formUserFileModel: [],
                formInsModel:{
                    Campaign: this.$route.params.referencia,
                    IdName: '',
                    IdLastname: '',
                    Mobile: '',
                    Email: '',
                    Document: '',
                    IdBanner: '',
                    IdRequest: '',
                    Message: '',
                    IdFile: '',
                },
                formBill:[
                    {            
                        id: 'IdName',
                        model: 'IdName',
                        name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Nombres',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                        required: true, 
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdLastname',
                        model: 'IdLastname',
                        name: 'Apellidos',
                        type: 'input',  
                        placeholder: 'Apellidos',
                        values: '',
                        validate: {              
                        required: true
                        },
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'Mobile',
                        model: 'Mobile',
                        name: 'Teléfono Celular',
                        type: 'input',  
                        placeholder: 'Teléfono Celular',
                        values: '',
                        validate: {
                        required: true, 
                        numeric: true,
                        max: 10,
                        min: 10 
                        },  
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'Email',
                        model: 'Email',
                        name: 'Correo Institucional',
                        type: 'input',  
                        placeholder: 'Correo Institucional',
                        values: '',
                        validate: {
                        required: true, 
                        email: true 
                        },
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'Document',
                        model: 'Document',
                        name: 'Documento de Identidad',
                        type: 'input',  
                        placeholder: 'Documento de Identidad',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdBanner',
                        model: 'IdBanner',
                        name: 'ID Banner',
                        type: 'input',  
                        placeholder: 'ID Banner',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6'               
                    },
                    {
                        id: 'IdRequest',
                        model: 'IdRequest',
                        name: 'Tipo de Solicitud',
                        type: 'Select',  
                        placeholder: 'Tipo de Solicitud',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: [
                            { id: "3229357000009313109", value: "ENVÍO DE ORDEN DE MATRÍCULA" },
                            { id: "3229357000061608321", value: "ENVÍO ORDEN DE MATRÍCULA REINTEGRO" },
                            { id: "3229357000009313083", value: "VERIFICACIÓN Y AMPLIACIÓN DE DESCUENTOS EN LA ORDEN DE MATRÍCULA" },
                            { id: "3229357000061608341", value: "ENVÍO ORDEN DE MATRÍCULA PRÓRROGA DE PAGO" },
                            { id: "3229357000061608361", value: "ENVÍO ORDEN DE MATRÍCULA FECHA ACTUALIZADA" },
                            { id: "3229357000002965655", value: "ABONOS A DEUDA - CARTERA" },
                            { id: "3229357000061608401", value: "ENVÍO RECIBO EXCEDENTE ORDEN DE MATRÍCULA" },
                        ],
                    },  
                    {            
                        id: 'Message',
                        model: 'Message',
                        name: 'Mensaje',
                        type: 'textarea',
                        hint: "Max 500 caracteres",
                        max: 500,
                        placeholder: 'Mensaje',
                        rows: 5,
                        values: '',
                        validate: 
                        {
                            required: true, 
                        },
                        class: 'col-md-12',
                        styleClasses: 'height: 200px'            
                    },
                    {
                        id: 'IdFile',
                        placeholder: 'Examinar',
                        name: 'Adjuntar archivo',
                        type: 'file',
                        values: '',
                        validate: {
                        required: false,
                        },
                        class: 'col-md-12'               
                    }
                ]
            }
        }
    }
</script>

<style scope>
.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 10px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.titleRef {
    font-weight: bold;
    padding-bottom: 10px;
    margin-top: 20px;
}

.titleForm {
    color: #000;
    font-size: 36px;
    font-weight: bold;
}

.descriptionForm {
    padding: 10px 10px 0px 10px;
    font-size: 20px;
    margin: 0px;
    text-align: justify;
    color: #222;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
    margin-bottom: 5px;
}

.container-form{
    padding: 30px 0;
    box-sizing: border-box;
}

.motBusUser{
    padding: 10px 10px 0px 10px;
    border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    background:  #ffffff !important;       
}

body {
    background:  #fff !important;   
}
header {
    background:  #ffffff !important;   
}

.table > tbody > tr > td {
     vertical-align: middle !important;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
  color: #222;
}

#IdObservation {
    height: 90px;
}

.active
{
  color: #222;
}

.botoPnrocess {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 10px;
}
button:hover {
    border-color: #222;
  background-color: #222;
  color: #fff;
}
.loginbtn {
    font-family: 'Poppins', sans-serif;
    display: inline-block;
    width: 250px;
    margin: 1rem 2rem;
    padding: 10px 10px;
    background-color: #fff;
    color: #222;
    border: #222 solid 3px;
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    text-transform: uppercase;
}

.validateBtn{
    width: 90%;
  background-color: #fff;
  border-color: #222 !important;
  color: #222;
  border-radius: 10px 10px;
  padding: 10px 0px 10px 0px;
  margin: 0px 10px 10px 10px;
}

/* Modal validación de datos */
.InscFiles{
    margin: 20px;
}

/* Grid validación data */
.wrapper {
  display: grid;
  margin: 10px 10px 10px 10px;
  padding: 1px 1px 1px 1px;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid black;
  grid-gap: 1px;
  background-color: black;
}

.wrapper > div {
  background-color: white;
  padding: 10px;
  text-align: center;
}

/* Estilos dedicados al Modal */
#btnClose{
    margin: 10px 10px 10px 10px;
    border-radius: 5px;
    border-color: #222;
    background-color: #fff;
    color: #222;
}
#btnClose:hover{
    background-color: #222;
    color: #fff;
}
hr{
    margin: 5px 10px;
}
.titleModal{
    font-size: 20px !important;
}
.v-easy-dialog--transition-ease-in {
    transform: scale(1);
    transition: opacity cubic-bezier(0.4, 0, 1, 1) 0.15s,
        transform cubic-bezier(0.4, 0, 1, 1) 0.15s;
}
.v-easy-dialog--transition-ease-out {
    transform: scale(1);
    transition: opacity cubic-bezier(0, 0, 0.2, 1) 0.15s,
        transform cubic-bezier(0, 0, 0.2, 1) 0.15s;
}
.v-easy-dialog--content-transition-opened {
    opacity: 1;
    transform: scale(1);
}
.v-easy-dialog--content-transition-closed {
    opacity: 0;
    transform: scale(0);
}
.v-easy-dialog--opacity-0 {
    opacity: 0;
}
.v-easy-dialog--opacity-100 {
    opacity: 100;
}
.v-easy-dialog--backdrop {
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    touch-action: none;
}
.v-easy-dialog--backdrop-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: default;
}
.v-easy-dialog--backdrop-btn:hover{
    background-color: rgba(0, 0, 0, 0) !important;
}
.v-easy-dialog--fullscreen {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
.v-easy-dialog--content-grow *:first-child {
    flex-grow: 1;
}
.v-easy-dialog--content-container {
    display: flex;
    overflow-y: auto;
    position: absolute;
    touch-action: none;
}
.v-easy-dialog--content-container:focus {
    outline: none;
}
.v-easy-dialog--persist {
    animation: shake 0.15s;
}

.textSend{
    background-color: #fff;
    border-radius: 10px;
}

.textSend div p{
    padding: 10px 10px 10px 10px;
    margin: 0px 0px 0px 0px;
    color: #000;
    font-size: 15px;
}
@keyframes shake {
    0% {
        transform: translate(1px, 1px) rotate(0deg);
    }
    20% {
        transform: translate(-3px, 0px) rotate(1deg);
    }
    40% {
        transform: translate(1px, -1px) rotate(1deg);
    }
    60% {
        transform: translate(-3px, 1px) rotate(0deg);
    }
    80% {
        transform: translate(-1px, -1px) rotate(1deg);
    }
    100% {
        transform: translate(1px, -2px) rotate(-1deg);
    }
}

</style>